import React from 'react';
import frame from './../assets/frame.png';

const HowItWorks = () => {
  return (
    <div className='hw-container'>
        <div className='hw-content text-center'>
        <h1 className='text-5xl font-bold text-[#1e1e1e] leading-[3rem] pt-5 pb-5'>How It Works</h1>
        <p className='text-lg leading-7 text-[#3F3F3F] pb-16'>From they fine john he give of rich he. They age and draw mrs like.Improving end<br />
        distrusts may instantly was household applauded incommode</p>

        <img src={frame} alt='' className='m-auto' />
        </div>
    </div>
  )
}

export default HowItWorks